
import React from 'react';
import AnimateInView from '@/components/ui/animate-in-view';

const ContactHero = () => {
  return (
    <section className="bg-gradient-to-r from-theme-contact-bg via-forti-fi-background/20 to-theme-contact-light py-16 px-4 relative overflow-hidden" aria-labelledby="contact-heading">
      <div className="absolute inset-0 bg-[url('/images/subtle-pattern.png')] opacity-5"></div>
      <AnimateInView animation="fade-in" className="container mx-auto max-w-4xl text-center relative z-10">
        <h1 id="contact-heading" className="text-black mb-4">Contact Us</h1>
        <p className="text-forti-fi-charcoal text-xl md:text-2xl mb-6 max-w-3xl mx-auto">
          Our security specialists are ready to discuss your specific requirements.
        </p>
      </AnimateInView>
    </section>
  );
};

export default ContactHero;
